import React, {useContext} from 'react';
import flatten from 'lodash/flatten';
import values from 'lodash/values';
import map from 'lodash/map';
import compact from 'lodash/compact';

import {Button} from 'components';

import FromModal from '@adsk/dh-akn-react-components/es/components/FormModal';

import './ModalAllGroups.scss';
import {AccordionTable} from '../AccordionTable/AccordionTable';
import {FooterTable} from '../FooterTable/FooterTable';
import styles from './ModalAllGroups.module.scss';
import Context from '../../context';

export const ModalAllGroups = () => {
  const {dataTable, filters} = useContext(Context);

  const filtersString = compact(map(flatten(values(filters)), 'label')).join(
    ', '
  );

  return (
    <FromModal
      appElement={document.getElementById('root')}
      TriggerButton={<Button type="link">View All</Button>}
      title={
        <>
          <div>Groups ({dataTable.length})</div>
          {filtersString && (
            <div className={styles.filters}>Filters: {filtersString}</div>
          )}
        </>
      }
    >
      <div className={styles.scroll}>
        <AccordionTable viewAll inModal />
      </div>
      <div className={styles.footer}>
        <FooterTable />
      </div>
    </FromModal>
  );
};

ModalAllGroups.propTypes = {};

ModalAllGroups.defaultProps = {};
